import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone, GraduationCap } from "lucide-react";
import { Button } from "./ui/button";
import logo from "@/assets/logo.png";

const navItems = [
  { label: "דף הבית", href: "/#home" },
  { label: "אודות", href: "/#about" },
  { label: "קורסים", href: "/courses" },
  { label: "צור קשר", href: "/#contact" },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 right-0 left-0 z-50 bg-background/95 backdrop-blur-md border-b border-border">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-3">
            <img src={logo} alt="מהדי - מכללה ובית ספר לנהיגה" width={193} height={56} className="h-14 w-auto" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-foreground/80 hover:text-primary font-medium transition-colors duration-300"
              >
                {item.label}
              </a>
            ))}
            <Button variant="outline" size="lg" className="gap-2" asChild>
              <a href="/register">
                <GraduationCap className="h-4 w-4" />
                <span>הרשמה לקורס</span>
              </a>
            </Button>
            <Button size="lg" className="gap-2">
              <Phone className="h-4 w-4" />
              <span>התקשרו עכשיו</span>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-foreground"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="תפריט"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden overflow-hidden"
            >
              <div className="py-4 space-y-4 border-t border-border">
                {navItems.map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    className="block py-2 text-foreground/80 hover:text-primary font-medium transition-colors"
                    onClick={() => setIsOpen(false)}
                  >
                    {item.label}
                  </a>
                ))}
                <Button variant="outline" size="lg" className="w-full gap-2" asChild>
                  <a href="/register">
                    <GraduationCap className="h-4 w-4" />
                    <span>הרשמה לקורס</span>
                  </a>
                </Button>
                <Button size="lg" className="w-full gap-2">
                  <Phone className="h-4 w-4" />
                  <span>התקשרו עכשיו</span>
                </Button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Navbar;
